export default __webpack_public_path__ + "static/media/PendingIcon.820016cb.svg";